// import { getUserPermissionInfo, login } from '@/services/demo/UserController';

// // POST请求事例
// export async function loginTest() {
//   const resData = await login({
//     username: 'admin',
//     password: 'admin123',
//     captchaVerification:
//       'PfcH6mgr8tpXuMWFjvW6YVaqrswIuwmWI5dsVZSg7sGpWtDCUbHuDEXl3cFB1+VvCC/rAkSwK8Fad52FSuncVg==',
//     socialType: 10,
//     socialCode: '1024',
//     socialState: '9b2ffbc1-7425-4155-9894-9d5c08541d62',
//   });
//   console.log(resData);
//   if (resData?.code === 200) {
//     //登陆成功后将token存起来
//     localStorage.setItem('tokens', resData?.data?.accessToken);
//     localStorage.setItem('refreshToken', resData?.refreshToken);
//   }
// }
// //get方式请求
// export async function queryUserPermissionInfo() {
//   const data = await getUserPermissionInfo();
//   console.log(data);
// }
